import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { Dish } from 'types';

export const getDish = async (dishId: number): Promise<Dish> => {
  const { data } = await axios.get(`/api/dishes/${dishId}`);
  return data as Dish;
};

type QueryFnType = typeof getDish;

type UseDishOptions = {
  dishId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useDish = ({ dishId, config }: UseDishOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['dishes', dishId],
    queryFn: () => getDish(dishId),
  });
};
